/* eslint-disable import/first */
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

window.$ = require("jquery");

import "bootstrap";
import "simplebar";
import "@fortawesome/fontawesome-free/js/all";
import "vanilla-lazyload";
import "bootstrap-maxlength";
import "jquery.easing";

import "iframe-resizer/js/iframeResizer.contentWindow";

import "../src/embed.scss";
import "../src/embed/pages/index";

import "controllers";

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// window.$ = $;
window.Rails = Rails;
